module.exports = "<p>\n  twitter-login-button works!\n</p>\n"